import axios from '../axios';

class Common{
    constructor() {
        this.revenue_class = '/template/revenue_class/list/';
        this.measures = '/template/common/measures';
        this.tax_codes = '/template/company_valid_sales_tax_codes/list';
        this.countries = '/template/common/countries';
        this.provance = '/template/common/countries/:code/';
        this.timezone = '/template/common/timezone';
        this.order_types = '/template/common/order_types';
        this.payment_types = '/template/common/payment_types';
        this.advantage = '/template/common/advantage';
        this.printer = '/printer/list';
    }
    getRevenueClass(params) {
        return axios(this.revenue_class, { method: 'get', params });
    }
    getMeasuresClass(params) {
        return axios(this.measures, { method: 'get', params });
    }
    getTaxCodes(params) {
        return axios(this.tax_codes, { method: 'get', params });
    }
    getCountries(params) {
        return axios(this.countries, { method: 'get', params });
    }
    getProvance(params) {
        return axios(this.provance, { method: 'get', params });
    }
    getTimezone(params) {
        return axios(this.timezone, { method: 'get', params });
    }
    getOrderTypes(params) {
        return axios(this.order_types, { method: 'get', params });
    }
    getPaymentTypes(params) {
        return axios(this.payment_types, { method: 'get', params });
    }
    getAdvantageTypes(params) {
        return axios(this.advantage, { method: 'get', params });
    }
    getPrinters(params) {
        return axios(this.printer, { method: 'get', params });
    }
};
export default new Common();



// WEBPACK FOOTER //
// ./src/api/modules/common.js